import { useEffect, useState } from "react";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import { mySpaceGetPinnedList, mySpaceMarkAsPin, mySpaceMarkAsUnpin } from "../../utils/api/mySpaceApi";
import { useDispatch, useSelector } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import { ReactComponent as GreenPin } from "../../assets/images/green_pin.svg";
import { ReactComponent as CardExcelIcon } from "../../assets/images/pinned_excel_icon.svg";
import { ReactComponent as AiIcon } from "../../assets/images/icons/z_ai.svg";
import { ReactComponent as ClosePopUpIcn } from "../../assets/images/closePopUpIcn.svg";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import AestheticDialog from "./AskAiDialog";
import DocumentIcon from "../../utils/utilityFunctions/iconUtility";
import { useNavigate } from "react-router";

const PinnedCard = ({ item, key, handleGetPinnedFileFolders, onClose }) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [showAskAiDialog, setShowAskAiDialog] = useState(false);

  const handleUnPinFileFolder = async (e, containerId) => {
    try {
      setIsApiLoading(true);
      e.stopPropagation();
      const response = await mySpaceMarkAsUnpin({ body: { containerId } });
      if (response?.success) {
        dispatch(pushAlert({ type: "success", message: response?.message || "Pinned successfully", visible: true }));
        handleGetPinnedFileFolders();
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message || "Something went wrong",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    } finally {
      setIsApiLoading(false);
    }
  };

  const handleRedirectToMySpace = (e) => {
    e.stopPropagation();
    if (item?.type === "folder") {
      navigate(`/my_space/folders/${item?.id}`);
    } else if (item?.type === "table") {
      navigate(`/my_space/tables/${item?.id}`);
    } else {
      const link = item?.file_url;
      window.open(link, "_blank");
    }
    onClose();
  };

  const handleClickAi = (e) => {
    e.stopPropagation();
    setShowAskAiDialog(true);
  };

  return (
    <div key={key} className="flex cursor-pointer justify-between items-center p-5 hover:bg-gray-100">
      <div onClick={handleRedirectToMySpace} className="flex justify-center items-center gap-3">
        <div className="p-3 rounded-full bg-[#E8E6E6]">
          {item?.type === "folder" ? (
            <DocumentIcon type="folder" fill={item?.code} />
          ) : (
            <DocumentIcon type={item?.type} filename={item?.mimetype} />
          )}
        </div>
        <div className="text-[#666]">
          <p className="text-[12px]">{item?.name}</p>
          <p className="font-light text-[11px]">
            {item?.created_by} <span>{moment(item?.created_at).format("YY/MM, hh:mm A")}</span>
          </p>
        </div>
      </div>
      <div className="flex justify-center items-center gap-3">
        {isApiLoading ? (
          <CircularProgress sx={{ width: "18px !important", height: "18px !important" }} />
        ) : (
          <ToolTipComponent text="Unpin">
            <GreenPin onClick={(e) => handleUnPinFileFolder(e, item?.id)} className="w-4 h-4 cursor-pointer" />
          </ToolTipComponent>
        )}
        <ToolTipComponent text="Ask AI">
          <AiIcon onClick={(e) => handleClickAi(e)} className="w-4 h-4 cursor-pointer" />
        </ToolTipComponent>
      </div>

      {showAskAiDialog && (
        <AestheticDialog
          open={showAskAiDialog}
          onClose={() => setShowAskAiDialog(false)}
          title="Ask AI"
          children={<></>}
        />
      )}
    </div>
  );
};
const MySpacePinnedDrawer = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const [pinnedList, setPinnedList] = useState([]);

  const handleGetPinnedFileFolders = async () => {
    try {
      const response = await mySpaceGetPinnedList();
      if (response?.success) {
        setPinnedList(response?.data);
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: response?.data?.message || "Something went wrong",
            type: "danger",
          })
        );
      }
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: error?.message || "Something went wrong",
          type: "danger",
        })
      );
    }
  };

  useEffect(() => {
    handleGetPinnedFileFolders();
  }, []);

  return (
    <CustomDrawer open={open} onClose={onClose}>
      <div className="flex justify-between items-center p-4 border-b-[1px] border-[]">
        <div className="flex items-center gap-3">
          <GreenPin />
          <p>Pinned</p>
        </div>

        <div onClick={onClose}>
          <ClosePopUpIcn />
        </div>
      </div>

      <div className="">
        {pinnedList?.length > 0 ? (
          pinnedList?.map((item, index) => (
            <PinnedCard
              item={item}
              key={index}
              handleGetPinnedFileFolders={handleGetPinnedFileFolders}
              onClose={onClose}
            />
          ))
        ) : (
          <div className="flex justify-center items-center p-5">
            <p>There are no pinned files</p>
          </div>
        )}
      </div>
    </CustomDrawer>
  );
};
export default MySpacePinnedDrawer;
